import { createContext } from "react";
import { initialDetailsReportFilters } from "pages/Corporate/Locations/MillDashboards/DetailsReport/DetailsReportFilters/useDetailsReportFilters";
import { IMillDetailsReportContext } from "./MillDetailsReportContextInterfaces";

export const initialState: IMillDetailsReportContext = {
    handleFiltersChange: () => {},
    filters: initialDetailsReportFilters,
    showFilters: false,
    handleShowFiltersChange: () => {},
    handleSetFiltersDefault: async () => {},
    handleRemoveDefaultFilters: async () => {},
    userFiltersDefault: null,
    loadingDefaultOperations: false,
};

export const MillDetailsReportContext = createContext(initialState);
